<style lang="sass" scoped>
.basicInfo,.platformInfo,.configInfo
  padding: 15px
h3
  margin-top: 40px
.el-button
  padding: 0px!important
.eyeIcon
  height: 20px
  vertical-align: middle
.table
  border: 1px solid #bfcbd9
  padding: 0px!important
  tbody
    tr
      td
        height: 80px
        &:nth-child(1)
          width: 50%
        &:nth-child(2)
          width: 50%
    tr:last-child
      td
        border-bottom: none
    .appPicture
      width: 40px
      height: 40px
      border-radius: 20px
      vertical-align: middle
.platformInfo
  div
    &:nth-child(n+2)
      margin-top: 40px
.configInfo
  div
    height: 60px
</style>

<template lang="pug">
.wrapper
  headers(:navNum="navNum", :username = "username")
  .layout-wrapper
    layout(v-loading="infoLoading")
      template(slot="page")
        h2 应用信息&nbsp;&nbsp;
          el-tooltip(effect="dark", placement="right")
            div(slot="content") 应用信息暂时不支持修改，如有需求请联系客服。
            i.el-icon-information
        h3(style="margin-top: 20px") 基础信息
        .basicInfo
          table.table
            tbody
              tr
                td 应用名称： {{basicInfo.appName}}
                td 应用图标：
                  img.appPicture(:src="basicInfo.appPicture")
              tr
                td 创建时间： {{time(basicInfo.createTime)}}
                td 审核反馈：
                  span.color-green(v-if="basicInfo.status === 1") 审核通过
                  span.color-yellow(v-else-if="basicInfo.status === 2") 审核中
                  span.color-red(v-else-if="basicInfo.status === 3") 未通过&nbsp;&nbsp;
                    el-tooltip(effect="dark", placement="right")
                      div(slot="content") {{basicInfo.refuse_msg}}
                      i.el-icon-information
                  span.color-grey(v-else) 删除
              tr
                td app Key： {{basicInfo.appKey}}
                td app Secret：
                  span(v-show="isAppSecretShow") {{basicInfo.appSecret}}&nbsp;&nbsp;
                    el-button(type="text", @click="switchApp(false)")
                      img.eyeIcon(src="../assets/睁眼.svg")
                  span(v-show="!isAppSecretShow") &nbsp;&nbsp;
                    el-button(type="text", @click="switchApp(true)")
                      img.eyeIcon(src="../assets/闭眼.svg")
              tr
                td(colspan='2') 应用介绍： {{basicInfo.appIntroduction}}

        h3 平台信息
        .platformInfo
          div 应用平台：  {{platformInfo.platform === 'i' ? 'IOS 平台' : 'Android 平台'}}
          div(v-show="platformInfo.platform === 'a'") 应用签名：  {{platformInfo.app_sign || '-'}}
          div {{platformInfo.platform === 'i' ? 'Bundle ID：' : '应用包名：'}}  {{platformInfo.package_name || '-' }}
        h3 高级配置
        .configInfo
          div 相同号码日消耗限额： {{configInfo.day_limit}} 次
          div 相同号码调用间隔：  {{configInfo.call_interval}} 秒
          div 应用日消耗限额：  {{configInfo.daily_consumption_limit}} 次
          div(style="word-break:break-all") RSA 公钥：
            span(v-show="isRSAShow") {{configInfo.RSAPublicKey}}&nbsp;&nbsp;
              el-button(type="text", @click="switchRSA(false)")
                img.eyeIcon(src="../assets/睁眼.svg")
            span(v-show="!isRSAShow") &nbsp;&nbsp;
              el-button(type="text", @click="switchRSA(true)")
                img.eyeIcon(src="../assets/闭眼.svg")
</template>

<script>
import headers from '../components/headers'
import layout from '../components/layout'
import { mapState } from 'vuex'

export default {
  components: { headers, layout },
  data () {
    return {
      navNum: 3,
      isAppSecretShow: false,
      isRSAShow: false
    }
  },
  computed: {
    ...mapState({
      basicInfo: state => state.application.basicInfo,
      platformInfo: state => state.application.platformInfo,
      configInfo: state => state.application.configInfo,
      infoLoading: state => state.application.infoLoading,
      username: state => state.dashboard.username
    })
  },
  mounted () {
    const id = this.$route.params.id;
    this.$store.dispatch('getPlatform', {platform_id: id});
  },
  methods: {
    time (value) {
      var timestamp = new Date(value * 1000); // 直接用 new Date(时间戳) 格式转化获得当前时间
      return timestamp.toLocaleDateString().replace(/\//g, '-') + ' ' + timestamp.toTimeString().substr(0, 8);
    },
    switchApp (value) {
      this.isAppSecretShow = value
    },
    switchRSA (value) {
      this.isRSAShow = value
    }
  }
}
</script>



// WEBPACK FOOTER //
// applicationInfo.vue?d7b44228